import React from 'react';
import { ArrowForwardOutlined, Group, Heading, Skeleton } from '@landr/maestro';
import { Link } from 'react-router-dom';
import { css } from '@landr/styled-system/css';

const iconStyle = css({
    verticalAlign: 'middle',
});

const Title = ({
    isLoading,
    content,
    to,
}: {
    isLoading: boolean;
    content?: string;
    to?: string;
}) => {
    if (isLoading) {
        return <Skeleton width="160px" height="28px" mb="md" />;
    }

    if (to) {
        return (
            <Link to={to}>
                <Heading as="h2" textStyle="title-sm" mb="2xs">
                    <Group gap="xs">
                        <Group.Item>{content}</Group.Item>
                        <Group.Item>
                            <ArrowForwardOutlined className={iconStyle} />
                        </Group.Item>
                    </Group>
                </Heading>
            </Link>
        );
    }

    return (
        <Heading as="h2" textStyle="title-sm" mb="2xs">
            {content}
        </Heading>
    );
};

export default Title;
